import { BigNumber, ethers } from 'ethers';

export interface IPayload {
  [key: string]:
    | {
        type: 'address';
        value: string | `0x${string}`;
      }
    | {
        type: 'uint256';
        value: number | bigint | BigNumber;
      }
    | {
        type: 'uint256[]';
        value: string[];
      };
}

export const encodeAbi = (payload: IPayload) => {
  const { params, values } = Object.values(payload).reduce(
    (agg: { params: string[]; values: any[] }, item) => {
      agg.params.push(item.type);
      agg.values.push(item.value);

      return agg;
    },
    { params: [], values: [] }
  );

  const encoded = ethers.utils.defaultAbiCoder.encode(params, values);
  const hashKeccak = ethers.utils.keccak256(encoded);
  return ethers.utils.arrayify(hashKeccak);
};
